/** Scoped entity key for person records (matches organization permission catalog). */
export const PERSON_SCOPED_ENTITY = 'person' as const;

/** Custom scoped actions for person records. */
export const PERSON_SCOPED_ACTION = {
  SEND_INVITE: 'sendInvite',
} as const;
